// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__19Na8","fileBtn":"File_fileBtn__2Dna8","closeBtn":"File_closeBtn__29WiB","fileSelected":"File_fileSelected__1YzBZ","disabled":"File_disabled__3FdTm"};